module.exports = __webpack_public_path__ + "static/media/iconCheck.f21201a9.svg";